import * as React from 'react';
import { ThreeColumnLayout, Box } from '../../CommonUI/Layout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StyleSheet, css } from 'aphrodite';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { Text } from 'ilenia';

interface GeneralListItemProps {
    actionColumn: React.ReactElement | string;
    label: React.ReactElement | string;
    description: React.ReactElement | string;
    checked: boolean;
}
export const GeneralListItem: React.SFC<GeneralListItemProps> = (props) => {
    const checkmark = (
        <Box mt="0px" pl="14px" pr="14px" width="52px">
            <FontAwesomeIcon icon={props.checked ? faCheckCircle : faCircle} className={props.checked ? css(styles.icon) : css(styles.circle)}/>
        </Box>
    );
    const middleText = (
        <Box>
            <Box className={css(styles.label, props.checked ? styles.checked : styles.unchecked)}>
                {typeof(props.label) === 'string' ? <Text id={props.label} /> : props.label}
            </Box>
            <Box className={css(styles.description)}>
                {typeof(props.description) === 'string' ? <Text id={props.description} /> : props.description}
            </Box>
        </Box>
    );
    return (
        <Box className={css(styles.item)} mt={0}>
            <ThreeColumnLayout statusColumn={checkmark} descriptionColumn={middleText} actionColumn={props.actionColumn}/>
        </Box>
    );
};

const styles = StyleSheet.create({
    item: {
        outline: 'solid 1px #e7e7e7',
    },
    icon: {
        color: 'rgb(98, 199, 134)',
        width: '24px',
        height: '24px',
    },
    checked: {
        color: 'rgb(102, 102, 102)',
    },
    unchecked: {
        color: 'rgb(41, 41, 41)',
        fontWeight: 'bold',
    },
    circle: {
        color: 'rgba(96, 96, 96, 0.56)',
        width: '24px',
        height: '24px',
    },
    label: {
        fontFamily: 'Lato',
        fontSize: '16px',
        fontWeight: 'normal',
        lineHeight: '23px',
    },
    description: {
        color: 'rgb(102, 102, 102)',
        fontFamily: 'Lato',
        fontSize: '14px',
        fontWeight: 'normal',
        lineHeight: '23px',
    }
});



// WEBPACK FOOTER //
// ./src/Components/General/GeneralListItem.tsx